'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = CaptiveFooter;

require('./captive-footer.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _HS_icon_Blue = require('common/images/HS_icon_Blue.svg');

var _HS_icon_Blue2 = _interopRequireDefault(_HS_icon_Blue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function CaptiveFooter() {

    // Inline to properly apply w/h to SVG
    var logoStyle = {
        width: 50,
        height: 50,
        float: 'left'
    };

    return _react2['default'].createElement(
        'div',
        { className: 'm-captive-footer columns' },
        _react2['default'].createElement(
            'div',
            { className: 'row' },
            _react2['default'].createElement('img', { style: logoStyle, src: _HS_icon_Blue2['default'] }),
            _react2['default'].createElement(
                'a',
                { href: '/info/aboutUs', target: '_blank', rel: 'noopener noreferrer' },
                'About HelloSign'
            ),
            _react2['default'].createElement(
                'a',
                { id: 'footer_contact', href: '#' },
                'Contact Support'
            ),
            _react2['default'].createElement(
                'span',
                { className: 'copyright' },
                'HelloSign \xA9 2016'
            )
        )
    );
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/footers/captive-footer.jsx
 ** module id = 1092
 ** module chunks = 0
 **/